var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconClose = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.8464 10.0327L18.3333 17.4869L17.5524 18.3333L10 10.8137L2.5131 18.3333L1.66667 17.4869L9.15357 10.0327L1.66667 2.5131L2.5131 1.66667L10 9.18631L17.5524 1.66667L18.3333 2.5131L10.8464 10.0327Z",
  fill: "currentColor"
})));
export default SvgIconClose;